import { CommonModule, DatePipe, NgClass, NgIf, NgStyle } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { SafePipe } from 'app/_pipes/safe.pipe';

@NgModule({
  declarations: [],
  imports: [NgIf, NgClass, NgStyle, RouterLink, CommonModule, SafePipe, ReactiveFormsModule, FormsModule, MatIconModule, MatFormFieldModule, MatInputModule, MatProgressBarModule, MatMenuModule, MatDialogModule, MatButtonModule, MatSelectModule, MatDatepickerModule, MatButtonToggleModule],
  exports: [NgIf, NgClass, NgStyle, RouterLink, CommonModule, SafePipe, ReactiveFormsModule, FormsModule, MatIconModule, MatFormFieldModule, MatInputModule, MatProgressBarModule, MatMenuModule, MatDialogModule, MatButtonModule, MatSelectModule, MatDatepickerModule, MatButtonToggleModule],
  providers: [DatePipe],
})
export class CommonFileModules {}
